import { type Theme } from './remoteTheme';

export const isFontLoaded = (font: string) => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  if (!context) {
    return false;
  }

  const testString = 'abcdefghi0123456789';
  const defaultFont = 'monospace';

  context.font = `40px ${defaultFont}`;
  const defaultWidth = context.measureText(testString).width;

  context.font = `40px "${font}", ${defaultFont}`;
  const customWidth = context.measureText(testString).width;

  return defaultWidth !== customWidth;
};

export const loadFont = async (fontName: string) => {
  await document.fonts.ready;

  if (isFontLoaded(fontName)) {
    return;
  }

  const googleFontName = fontName.replace(' ', '+');
  const url = `https://fonts.googleapis.com/css2?family=${googleFontName}:wght@100..900&display=swap`;
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = url;
  document.head.appendChild(link);
};

export const extractFontFamilies = (theme: NonNullable<Theme['antd']>) =>
  new Set(
    Object.values(theme).flatMap(mode => [
      ...(mode.token?.fontFamily ? [mode.token.fontFamily] : []),
      ...Object.values(mode.components || {}).flatMap(component =>
        (component as Record<string, any>).fontFamily ? [(component as Record<string, any>).fontFamily] : []
      )
    ])
  );
